import { cn } from "@reactive-resume/utils";
import { forwardRef, type InputHTMLAttributes } from "react";

// Même apparence que SmartCombobox, sans suggestions.
export const FreeTextInput = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  ({ className, ...props }, ref) => (
    <input
      ref={ref}
      type="text"
      autoComplete="off"
      className={cn(
        "min-h-10 w-full rounded-xl border border-slate-200 bg-white px-3 text-xs text-indigo-950 outline-none",
        "transition focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100",
        className,
      )}
      {...props}
    />
  ),
);

FreeTextInput.displayName = "FreeTextInput";
